export default "__VITE_ASSET__Djin7roR__"